<div class="container">
  <app-tagging-label-builder></app-tagging-label-builder>
</div>
